import Vue from 'vue'

const publicPath = process.env.BASE_URL

const plugin = function (Vue, options) {
  Vue.prototype.$publicPath = publicPath
  Vue.$publicPath = publicPath
}

Vue.use(plugin)
